import getProp from '@f/get-prop'

export const getCreatingSourceSettingRequest = (state, workspaceSlug) =>
  getProp(`createSourceSettingRequest.${workspaceSlug}`, state) || {}

export const isCreatingSourceSetting = (state, workspaceSlug) =>
  getProp(`createSourceSettingRequest.${workspaceSlug}.isRequesting`, state) || false

export const didFailToCreateSourceSetting = (state, workspaceSlug) =>
  getProp(`createSourceSettingRequest.${workspaceSlug}.didRequestFail`, state) || false



// WEBPACK FOOTER //
// ./selectors/create-source-setting-request.js